// eslint-disable-next-line import/no-cycle
import transferService from '@client/services/transfers';

const stateObj = () => ({
  accountLimits: {
    accountTypeId: null,
    year: null,
    accountTypeName: '',
    limits: [],
  },
});

const actions = {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  async getAccountLimitsMS({commit}, {accountType, year}) {
    const accountLimits = await transferService.getAccountLimits(accountType, year);

    return accountLimits;
  },
};

export default {
  namespaced: true,
  state: stateObj,
  actions,
};
